import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/scene-load-store/scene-load-store.ts
var r = {
	entries: {},
	overallProgress: 0,
	bytesReceived: 0,
	sizeInBytes: 0,
	running: 0,
	isLoading: !1
}, i = e((e) => ({
	...r,
	set: (t) => e(t),
	reset: () => e({
		...r,
		entries: {}
	})
})), a = (e) => t(i, n(e));
//#endregion
export { i as sceneLoadStore, a as useSceneLoadStore };
